export const Common = {
  titleProject: 'Moviment@',
  labelEmail: 'E-mail',
  labelPassword: 'Palavra-Passe',
  login: 'Iniciar Sessão',
  logout: 'Sair',
  send: 'Enviar',
  back: 'Voltar',
  register: 'Registar',
  cancel: 'Cancelar',
  reschedule: 'Re-Agendar',
  schedule: 'Agendar',
  confirm: 'Confirmar',
  filter: 'Filtrar',
  filters: 'Filtros',
  clean: 'Limpar',
  restore: 'Restaurar',
  report: 'Reportar',
  success: 'O seu pedido foi efectuado com sucesso.'
}



// WEBPACK FOOTER //
// ./src/translations/pt/common.js